<template>
  <mdb-container fluid id="help">
    <mdb-row class="pt-3 pb-3 mb-3 d-flex blue-header">
      <mdb-col class="col-12 text-left pl-4 pr-4">
        <img
          class="logo"
          src="../assets/img/csc-white.svg"
          width="140"
          height="49"
        />
        <a
          class="link light consult-position"
          target="_blank"
          href="https://www.csc.gov.au/Employers/Contact-us"
        >
          <img
            class="icon-arrow-help"
            src="../assets/icons/big-arrow-white-outline.svg"
          />
          <span>Need help? Contact us</span>
        </a>
      </mdb-col>
    </mdb-row>

    <mdb-row class="flex-row pt-4 mb-lg-5" responsive>
      <div class="help-inset">
        <mdb-container fluid class="h-100 help">
          <mdb-row class="text-left dots-left pb-sm-5">
            <mdb-col class="col-8 col-sm-12 p-0 pt-5 pb-3 big-circle">
              <h2>
                When should I use AWOTE?
              </h2>
            </mdb-col>
          </mdb-row>

          <mdb-row class="text-left dots-left">
            <mdb-col class="pl-5 pt-4 pb-4 med-circle">
              <mdb-tabs
                :active="0"
                pills
                navClass="csc-nav"
                :links="[
                  { text: 'PSS/PSSap', slot: 'pss' },
                  { text: 'CSS', slot: 'css' }
                ]"
                :transition-duration="0.2"
                transition-style="linear"
              >
                <template :slot="'pss'">
                  <div class="pt-4 pb-3">
                    <p>
                      Use this calculator if your employee has had a
                      <em>salary reduction</em>
                      since the last salary review, and you're performing:
                    </p>
                    <ul>
                      <li>
                        a birthday review for a PSS member;
                      </li>
                      <li>
                        an exit review for a PSS member being retrenched;
                      </li>
                      <li>
                        a fortnightly contribution salary (FCS) review for a
                        PSSap member
                      </li>
                    </ul>
                    <p>
                      A <em>salary reduction</em> is a reduction in the
                      employees hourly salary (including recognised allowances),
                      even if their salary later increased.
                    </p>
                    <p>
                      If the calculator advises that a maintained salary
                      applies, you must continue to use the calculator at each
                      future salary review.
                    </p>
                  </div>
                </template>

                <template :slot="'css'">
                  <div class="pt-4 pb-3">
                    <p>
                      Use this calculator if your employee has had a
                      <em>salary reduction</em> since the last salary review,
                      and you're performing:
                    </p>
                    <ul>
                      <li>
                        a birthday review;
                      </li>
                      <li>
                        an exit review for a member being retrenched or ceasing
                        work after minimum retirement age.
                      </li>
                    </ul>
                    <p>
                      A salary <em>reduction</em> occurs if the employee's
                      annual salary (including recognised allowances) at this
                      review is lower than it was at any time since the last
                      review.
                    </p>
                    <p>
                      If the calculator advises that a maintained salary
                      applies, you must continue to use the calculator at each
                      future salary review.
                    </p>
                    <p>
                      *Please
                      <a
                        href="https://www.csc.gov.au/Employers/Contact-us"
                        target="parent"
                        class="underln"
                        >contact us</a
                      >
                      if you're calculating super salary for a member whose
                      salary reduction occurred before 1 July 2003.
                    </p>
                  </div>
                </template>
              </mdb-tabs>
            </mdb-col>
          </mdb-row>

          <mdb-row class="text-left">
            <mdb-col class="pl-5 pt-2 pb-4 x-small-circle">
              <h4>
                Need help?
              </h4>
              <p>
                <a
                  class="underln"
                  target="_blank"
                  href="https://www.csc.gov.au/Employers/Contact-us"
                >
                  Click here</a
                >
                to contact us.
              </p>
            </mdb-col>
          </mdb-row>

          <mdb-row class="text-right csc-btns-btm">
            <mdb-col class="pt-3 pb-3">
              <router-link
                to="/"
                class="rounded btn btn-outline-primary ripple-parent"
              >
                Back
              </router-link>
              <router-link
                to="/about"
                class="rounded btn btn-primary ripple-parent"
              >
                Start <i class="fas icon-arrow"></i>
              </router-link>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </div>
    </mdb-row>

    <mdb-row class="no-gutters">
      <mdb-col>
        <Footer />
        <div id="feedback">
          <a
            href="https://feedback.csc.gov.au/cgi-bin/qwebcorporate.dll?idx=SQ6N45&type=AHC"
            target="_blank"
          >
            Feedback
          </a>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<style lang="scss">
@import "~@/scss/help.scss";
</style>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbTabs } from "mdbvue";

import Footer from "@/components/Footer.vue";

export default {
  name: "Help",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbTabs,
    Footer
  },
  mounted() {
    window.triggerResize();
  }
};
</script>
